/**
 * {@link https://ngrx.io/docs State} of a given entity plugin manager
 */
export interface State {
  /**
   * Indicates the current status of all plugins
   *
   * We only have one status for all plugins because they are instantiated and
   * initialized as a group
   */
  pluginsStatus?: 'instantiated' | 'initialized'
}
export namespace State {
  export const INITIAL: State = {}
}
